import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

import store from '../store/'

import middlewarePipeline from './middlewarePipeline'
import authMiddle from './middleware/auth'
import authAdminMiddle from './middleware/authAdmin'

const routes = [
  {
    path: '/',
    name: 'home',
    meta : {
        navKey : 1,
        middleware: [
          authMiddle
        ]
    },
    component: HomeView
  },
  {
    path: '/booking',
    name: 'booking',
    meta : {
      navKey : 2,
      middleware: [
        authMiddle
      ]
    },
    component: ()=>import('../views/BookingView.vue'),
  }, 
  {
    path: '/booking/success',
    name: 'bookingSuccess',
    meta : {
      navKey : 3,
      middleware: [
        authMiddle
      ]
    },
    component: ()=>import('../views/BookingSuccessView.vue'),
  }, 
  {
    path: '/booking/my',
    name: 'bookingMy',
    meta : {
      navKey : 4,
      middleware: [
        authMiddle
      ]
    },
    component: ()=>import('../views/BookingMyView.vue'),
  }, 
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue')
  }, 
  {
    path: '/auth/callback',
    name: 'authCallback',
    component: () => import('../views/AuthCallback.vue')
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/AdminView.vue'),
    children: [{
      path: 'login',
      name: 'adminLogin',
      meta : {
        navKey : 5,
        middleware: [
          authMiddle
        ] 
      },
      component: ()=>import('../views/AdminLoginView.vue'),
    },{
      path: 'billing',
      name: 'adminBilling',
      meta : {
        navKey : 6,
        middleware: [
          authAdminMiddle
        ] 
      },
      component: ()=>import('../views/AdminBillingView.vue'),
    },{
      path: 'calendar',
      name: 'adminCalendar',
      meta : {
        navKey : 7,
        middleware: [
          authAdminMiddle
        ] 
      },
      component: ()=>import('../views/AdminCalendarView.vue'),
    },{
      path: 'equipment',
      name: 'adminEquipment',
      meta : {
        navKey : 8,
        middleware: [
          authAdminMiddle
        ] 
      },
      component: ()=>import('../views/AdminEquipmentView.vue'),
    }],
  },
  {
    path: '/public/calendar',
    name: 'publicCalendar',
    meta: {
      title: '預約日曆'
    },
    component: () => import('../views/PublicCalendarView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {

  if (!to.meta.middleware) {
    return next()
  }
  const middleware = to.meta.middleware
  const context = {
    to,
    from,
    next,
    store
  }

  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1)
  })
})

export default router
